import React from 'react';

import SimpleMessagePage from 'components/SimpleMessagePage';
import EmbeddedContinueButton from 'features/EmbeddedContinueButton';

import {
  useMarkdownTranslate,
  useMarkdownMultilineTranslate,
} from 'hooks/useTranslate/useTranslate';

const Pending: React.FC = () => {
  const tMd = useMarkdownTranslate();
  const tMdMulti = useMarkdownMultilineTranslate();
  return (
    <SimpleMessagePage
      headerTitle={'unified.application.pending.title'}
      message={tMdMulti('unified.application.pending.message')}
    >
      <EmbeddedContinueButton>
        {tMd('unified.application.pending.continueButton')}
      </EmbeddedContinueButton>
    </SimpleMessagePage>
  );
};

export default Pending;
